import { Component } from '@angular/core';
import { LayoutComponent } from './core/layouts/layout/layout.component';

@Component({
  selector: 'app-root',
  imports: [LayoutComponent],
  templateUrl: './app.html',
})
export class App {}
